export default __webpack_public_path__ + "static/07.04-251b1dad32cd9bc8548be267af82d029.png";